import DueDateSelect, {
  type DueDateValue,
} from "@/components/form/due-date-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a `{ key, value }` due-date pair**, not a bare date string. */
export type DueDateFieldProps = PickerFieldProps<DueDateValue>;

export const DueDateField = makePickerField<DueDateValue>({
  name: "DueDateField",
  control: DueDateSelect,
  popout: true,
});
